import { render, staticRenderFns } from "./ClassTableForm.vue?vue&type=template&id=990f5352"
import script from "./ClassTableForm.vue?vue&type=script&lang=js"
export * from "./ClassTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports